import { HeightProps, WidthProps } from 'styled-system';

import { Box } from 'components/Box';
import { Icon } from 'components/Icon';

import { StyledSelect } from './SelectInput.styled';

type Props = HeightProps &
  WidthProps & {
    'aria-label'?: string;
    id?: string;
    label?: string;
    className?: string;
    name?: string;
    customCompare?: (
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      arg0: Record<string, any>,
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      arg1: Record<string, any>
    ) => boolean;
    disableGreyOnNull?: boolean;
    disabled?: boolean;
    value?: string;
    options: ReadonlyArray<{
      value: string | number | null | undefined;
      label: string;
      disabled?: boolean;
    }>;
    onChange?: (arg0: string) => void;
    'data-qa-id'?: string;
    hasError?: boolean;
    small?: boolean;
    required?: boolean;
    placeholder?: string | null | undefined;
  };

export function SelectInput({
  name,
  value,
  options,
  onChange = () => undefined,
  hasError,
  small,
  ...props
}: Props) {
  return (
    <Box position="relative">
      {/* @ts-expect-error TS(2769): No overload matches this call. */}
      <StyledSelect
        name={name}
        small={small}
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        hasError={hasError}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      >
        {options.map(({ value: optionValue, label, ...optionProps }) => (
          // TODO: Fix this the next time the file is edited.
          // @ts-expect-error TS(2322): Type 'string | number | null | undefined' is not a... Remove this comment to see the full error message
          // eslint-disable-next-line react/jsx-props-no-spreading
          <option key={optionValue} value={optionValue} {...optionProps}>
            {label}
          </option>
        ))}
      </StyledSelect>
      <Box
        position="absolute"
        top="50%"
        right={small ? 12 : 19}
        transform="translateY(-50%)"
        pointerEvents="none"
      >
        <Icon
          initialColorName="todo-replace-me"
          name="chevron-down"
          size={small ? 10 : 16}
        />
      </Box>
    </Box>
  );
}
